import { URLS } from '@/pages/urls'
import { Button } from '@/ui-kit'
import { Drawer, DrawerClose, DrawerContent, DrawerFooter, DrawerHeader, DrawerTitle } from '@/ui-kit/components/Drawer'
import { isAndroidMobile } from '@/utils/isAndroidMobile'
import { useSessionStorage } from '@/utils/useSessionStorage'
import clsx from 'clsx'
import { useInviteCode } from './InviteCodeProvider'

export const AndroidMobileAppDrawer = () => {
  const { inviteCode } = useInviteCode()
  const [isOpen, setIsOpen] = useSessionStorage('INSTALL_MOBILE_APP_DRAWER_OPEN', true)

  if (!isAndroidMobile()) {
    return null
  }

  const handleOpenMobileApp = () => {
    window.open(URLS.ANDROID_APP(inviteCode ?? undefined))
  }

  return (
    <Drawer open={isOpen}>
      <DrawerContent>
        <div className="relative -mx-3 -mt-[54px] h-[150px] overflow-hidden border-b border-solid border-gray-100 px-3">
          <img
            className={clsx('absolute bottom-0 left-1/2 h-auto h-full -translate-x-1/2 object-cover')}
            src="/images/hand.png"
            alt=""
          />
        </div>
        <DrawerHeader>
          <DrawerTitle className="mx-auto max-w-[250px] !text-[22px]/[22px] font-semibold">
            DataHive AI Mobile App is available
          </DrawerTitle>
        </DrawerHeader>
        <DrawerFooter>
          <Button onClick={handleOpenMobileApp}>Download from Play Market</Button>
          <DrawerClose asChild className="w-full">
            <Button onClick={() => setIsOpen(false)} variant="bordered">
              Continue in browser
            </Button>
          </DrawerClose>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  )
}
